<template lang="pug">
div
    button.change-button(
      :disabled="disabled || loading"
      v-if="showButton"
      @click="showModal"
      @hide="hideModal()"
      data-testid="action-btn-diagnosticar"
    ) Diagnosticar
      b-spinner(v-if="loading" class="ml-2" variant="white" small)
    SamtekModal(
      v-model="show"
      size="lg"
      :title="ot.diagnostico === null ? 'Crear Diagnóstico' : 'Editar Diagnóstico'"
      @shown="onModalShown"
      @hide="onModalHide"
    )
      b-form-group(
        label-for="input-falla"
        label="¿Se pudo replicar la falla?"
      )
        b-form-radio(v-model="form.replicar_falla" :value="true"
          :state="$v.form.replicar_falla.$dirty ? !$v.form.replicar_falla.$invalid : null"
          data-testid="radio-replicar-si"
        ) Sí
        b-form-radio(v-model="form.replicar_falla" :value="false"
          :state="$v.form.replicar_falla.$dirty ? !$v.form.replicar_falla.$invalid : null"
        ) No
      .errors(v-if="$v.form.replicar_falla.$dirty")
        b-form-invalid-feedback(:state="$v.form.replicar_falla.required")
          | Campo requerido
      b-form-group(
        label-for="input-informe"
        label="Diagnóstico:"
      )
        b-form-textarea(
          id="input-informe"
          rows="5"
          v-model="form.informe"
          placeholder="Registrar el diagnóstico (obligatorio)"
          data-testid="input-diagnostico"
          :state="$v.form.informe.$dirty ? !$v.form.informe.$invalid : null")
        .errors(v-if="$v.form.informe.$dirty")
          b-form-invalid-feedback(:state="$v.form.informe.required")
            | Campo requerido

        OTUploads(v-if="show" :ot="ot", fileNamePattern="evidencia-diagnostico" :attachmentType="ARCHIVO_ADJUNTO_TIPO.EVIDENCIA")

      .piezas-sugeridas-section.mt-3(v-if="ot.tipo_servicio && ot.tipo_servicio.id === 4")
        hr.my-2
        h6.font-weight-bold.mb-2 Repuestos solicitados para cotización
        div(v-if="loadingPiezas")
          b-spinner(small)
          span.ml-2 Cargando repuestos...
        div(v-else-if="piezasSugeridas.length > 0")
          b-table.piezas-table(
            :fields="piezasFields"
            :items="piezasSugeridas"
            small
            responsive
            borderless
            thead-class="piezas-thead"
          )
            template(#head(seleccionada))
              b-form-checkbox(
                :checked="todasSeleccionadas"
                :indeterminate="algunaSeleccionada && !todasSeleccionadas"
                @change="toggleSeleccionarTodo"
              )
            template(#cell(seleccionada)="{ index }")
              b-form-checkbox(v-model="piezasSugeridas[index].seleccionada")
        p.text-muted.small(v-else) No hay repuestos solicitados por el técnico para esta OT.

      template(#modal-footer='{ ok, cancel, hide }')
        b-button.btn-samtek-secondary(size='sm' variant='light' @click='hideModal()') Cancelar
        b-button.btn-samtek-primary(size='sm' @click='saveDiagnostic()', :disabled="loading" id="btn-guardar-diagnostico" data-testid="modal-save-diagnostico") Guardar
          b-spinner(v-if="loading" class="ml-2" variant="white" small)
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'
import { ARCHIVO_ADJUNTO_TIPO } from '@/utils/enums'
import OTUploads from '../OTUploads.vue'

export default {
  components: {
    OTUploads,
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'),
  },
  mixins: [LoadingButtonMixin],
  name: 'ActionDiagnosticar',
  props: ['ot', 'disabled'],

  validations: {
    form: {
      replicar_falla: { required },
      informe: { required },
    },
  },
  data() {
    return {
      show: false,
      loading: false,
      showButton: true,
      form: {
        replicar_falla: this.ot.diagnostico_detail
          ? this.ot.diagnostico_detail.replicar_falla
          : null,
        informe: this.ot.diagnostico_detail
          ? this.ot.diagnostico_detail.informe
          : null,
        id: this.ot.diagnostico_detail ? this.ot.diagnostico_detail.id : null,
        orden_trabajo: this.ot.ot,
      },
      piezasSugeridas: [],
      loadingPiezas: false,
      piezasFields: [
        { key: 'seleccionada', label: '' },
        { key: 'codigo', label: 'Código/Part Number' },
        { key: 'descripcion', label: 'Descripción' },
      ],
    }
  },
  methods: {
    ...mapActions('Diagnosticos', [
      'createDiagnoseOT',
      'updateDiagnoseOT',
      'createPreDiagnosticOT',
      'getPiezasSugeridas',
    ]),
    ...mapActions('OTStore', ['getOT']),
    showModal() {
      // this.startLoading()
      this.show = true
    },
    async onModalShown() {
      if (this.ot.tipo_servicio && this.ot.tipo_servicio.id === 4) {
        this.loadingPiezas = true
        try {
          const partesSolicitadas = (this.ot.solicitud_partes || []).filter(
            (sp) => !['Dropped', 'Part failed'].includes(sp.estado)
          )
          const grouped = {}
          partesSolicitadas.forEach((sp) => {
            const parteId = sp.parte.id
            if (!grouped[parteId]) {
              grouped[parteId] = {
                id: parteId,
                codigo: sp.parte.part_number,
                descripcion: sp.parte.description,
                seleccionada: true,
              }
            }
          })
          let piezas = Object.values(grouped)
          if (this.ot.diagnostico_detail) {
            const resp = await this.getPiezasSugeridas(this.ot.ot)
            if (resp && resp.status === 200) {
              const savedIds = new Set(
                (resp.data.piezas_sugeridas || []).map((p) => p.id)
              )
              piezas = piezas.map((p) => ({
                ...p,
                seleccionada: savedIds.has(p.id),
              }))
            }
          }
          this.piezasSugeridas = piezas
        } catch (e) {
          console.error('Error al cargar repuestos solicitados:', e)
        } finally {
          this.loadingPiezas = false
        }
      }
    },
    onModalHide() {
      // this.stopLoading()
    },
    hideModal() {
      this.show = false
    },
    toggleSeleccionarTodo(checked) {
      this.piezasSugeridas.forEach((pieza) => {
        pieza.seleccionada = checked
      })
    },
    async saveDiagnostic() {
      if (this.$v.$invalid) {
        this.$bvToast.toast('Complete todo los campos requeridos', {
          variant: 'danger',
        })
        this.$v.$touch()
        return
      }

      try {
        await this.executeWithLoading(async () => {
          const isPresupuesto = this.ot.tipo_servicio && this.ot.tipo_servicio.id === 4
          const action = this.ot.diagnostico_detail
            ? this.updateDiagnoseOT
            : isPresupuesto
            ? this.createPreDiagnosticOT
            : this.createDiagnoseOT
          const payload = { ...this.form }
          if (isPresupuesto) {
            payload.partes_sugeridas = this.piezasSugeridas
              .filter((p) => p.seleccionada)
              .map((p) => ({
                id: p.id,
                cantidad: 1,
              }))
          }
          const response = await action(payload)
          if (response.status === 200) {
            this.$bvToast.toast('Diagnóstico guardado.', {
              variant: 'success',
            })
            await this.getOT(this.ot.ot)
            this.$emit('changed')
            this.show = false
          } else {
            this.$bvToast.toast(
              `Error al guardar el diagnóstico: ${response.data}`,
              {
                variant: 'danger',
              }
            )
          }
        })
      } catch (error) {
        console.error('Error al guardar diagnóstico:', error)
        this.$bvToast.toast('Error al guardar diagnóstico', {
          variant: 'danger',
        })
      }
    },
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
    ...mapGetters('OTStore', ['statusRequest']),
    ARCHIVO_ADJUNTO_TIPO: () => ARCHIVO_ADJUNTO_TIPO,
    todasSeleccionadas() {
      return this.piezasSugeridas.length > 0 && this.piezasSugeridas.every((p) => p.seleccionada)
    },
    algunaSeleccionada() {
      return this.piezasSugeridas.some((p) => p.seleccionada)
    },
  },
  watch: {
    'ot.solicitud_partes': {
      handler(newVal) {
        if (
          newVal.some(
            (parte) =>
              parte.estado === 'solicitado' &&
              !parte.allocated &&
              this.ot.tipo_servicio.id === 4
          )
        ) {
          this.showButton = false
        } else {
          this.showButton = true
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.preview,
.capture {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
img {
  width: 100%;
}
.webcam {
  display: inline-flex;
  justify-content: space-between;
  margin: -8pxl;
}
.form-group {
  min-height: 100% !important;
}

.piezas-table {
  background-color: #fff;
}

::v-deep .piezas-thead th {
  background-color: #e9ecef;
  border: none;
  font-weight: 600;
  color: #333;
}

::v-deep .piezas-table td {
  border: none;
  vertical-align: middle;
}
</style>
